module.exports = __webpack_public_path__ + "img/Osterfeuer-brennt.63021bc1.jpg";